module.exports = __webpack_public_path__ + "media/images/2_regist_user_inactive-e0814915.png";